import React, {useEffect} from 'react';
import {listaFocusHobs} from "../../../../data/hobs/hobs-data";
import ProductGrid from "../../../../components/prodotti/ProductGrid";

const FocusHobs = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <ProductGrid prodotti={listaFocusHobs} name={"Our Focus Line hobs"}/>
    );
};

export default FocusHobs;
